import { render, staticRenderFns } from "./algo-order-summary.component.vue?vue&type=template&id=99c3cfce&scoped=true"
import script from "./algo-order-summary.component.vue?vue&type=script&lang=js"
export * from "./algo-order-summary.component.vue?vue&type=script&lang=js"
import style0 from "./algo-order-summary.component.vue?vue&type=style&index=0&id=99c3cfce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c3cfce",
  null
  
)

export default component.exports